import type JSONFormatter from 'json-formatter-js'
import { parse, stringify } from 'flatted'

let _formatter: null | JSONFormatter = null

/**
 * Formatter as SSR-save import
 * @returns {Promise<JSONFormatter>}
 */
export async function getJSONFormatter(): Promise<JSONFormatter> {
  if (_formatter) {
    return _formatter
  }
  const formatter = await import('json-formatter-js')
  _formatter = new formatter.default({}, Infinity)
  return _formatter
}

export function jsonify(json: unknown) {
  const transformed = stringify(json || {}, (_key, value) => {
    if (value instanceof Set) {
      return [...value]
    }
    if (value instanceof Map) {
      return [...value.entries()]
    }
    return value
  })
  return parse(transformed)
}
